module.exports = __webpack_public_path__ + "img/news_01.04b78d1b.jpg";